// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { LogonMessage } from '../Messages/LogonMessage';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { TimeZoneInfo } from '@shared/utils/Time/TimeZoneInfo';
export class LogonMessageProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const logon = new LogonMessage(fieldSet);
        // this.decoder.TimeZone = logon.getTimeZone();
        const serverTimeZoneId = fieldSet.IsSetField(FieldsFactory.FIELD_TIME_ZONE_ID)
            ? fieldSet.GetValue(FieldsFactory.FIELD_TIME_ZONE_ID)
            : '';
        this.decoder.TimeZoneId = serverTimeZoneId;
        TimeZoneInfo.SERVER_TIME_ZONE = serverTimeZoneId;
        return [logon];
    }
}
